import { render, staticRenderFns } from "./SingleCalendarItemWidget.vue?vue&type=template&id=525dbd66&scoped=true"
import script from "./SingleCalendarItemWidget.vue?vue&type=script&lang=js"
export * from "./SingleCalendarItemWidget.vue?vue&type=script&lang=js"
import style0 from "./SingleCalendarItemWidget.vue?vue&type=style&index=0&id=525dbd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dbd66",
  null
  
)

export default component.exports